import React, { useState, useEffect, FC } from 'react';
import { Grid } from 'semantic-ui-react';
import { dappSocialVault } from '../ethereum/web3';
import NFTCard from '../components/NFTCard';

interface IBuyProps {
  vaults?: [];
}

const Fund:FC<IBuyProps> = (props: IBuyProps) => {
  const [vaults, setVaults] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(true);

  async function getVaultDetails() {
    try {
      setLoading(true);
      const numberOfVaults = await dappSocialVault.getNumberOfVaults();

      const vaults = await Promise.all(
          Array(parseInt(numberOfVaults)).fill(undefined).map((element, index) => {
              return dappSocialVault.getVaultIdDetails(index);
          })
      );
      setVaults(vaults);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getVaultDetails();
  }, []);

  function renderVaults(vaults: any) {
    if (vaults.length === 0) {
      return (<h1>Nothing to buy</h1>);
    }

    const vaultComponents = vaults.map((vault: any) => {
      return <NFTCard
        key={vault[5]}
        address={vault[5]}
        name={vault[1]}
        stakedAmount={vault[2].toString()}
        targetAmount={vault[3].toString()}
        url={vault[6]}
      />
    });

    return vaultComponents;
  }

  return(
    <Grid columns='equal'>
      <Grid.Column width={1}>
        <div className="outer">
          <div className="inner rotate">CROWD&nbsp;FUND</div>
        </div>
      </Grid.Column>
      <Grid.Column>
        <div className="App-header">
            { loading ? 'Loading...' : renderVaults(vaults) }
        </div>
      </Grid.Column>
      <Grid.Column width={2} />
    </Grid>
  )
}

export { Fund };
